/**
 * How often the dialer re-reads its data (DX-8), in one place.
 *
 * ENG-4: the active-call query is the live-call controller: it polls on
 * every dialer route, unchanged (a line ringing re-reads every second, even
 * in a background tab). The queue and history are display lists: they poll
 * only on the screens that show them, or while a session dials (the next
 * batch is chosen from them). Elsewhere (Performances, Facturation,
 * Paramètres, Équipe…) they are read on mount and on focus, not every 3-5 s.
 * SSE events only invalidate; they never replace these intervals.
 */
export const POLLING = {
  queueMs: 5000,
  callsMs: 3000,
  activeCallPendingMs: 1000,
  activeCallSessionMs: 5000,
  activeCallIdleMs: 10000,
} as const;

/** Screens that show the queue or the call history (paths under /ParallelDialer). */
const LIVE_LIST_PATHS = new Set(['', 'contacts', 'home', 'followups', 'call-history']);

export function displayListsPoll(pathname: string, sessionActive: boolean): boolean {
  if (sessionActive) return true;
  const m = /^\/ParallelDialer\/?([^/?#]*)/.exec(pathname);
  return m !== null && LIVE_LIST_PATHS.has(m[1] ?? '');
}
